import { Injectable, signal } from '@angular/core';
import { Capacitor } from '@capacitor/core';

@Injectable({
	providedIn: 'root',
})
export class NativeService
{
	constructor(
	)
	{
	}

	public async isNative(): Promise<boolean>
	{
		try
		{
			const isNative = await Capacitor.isNativePlatform();
			console.debug('Is native platform:', isNative);
			return isNative;
		}
		catch (error)
		{
			console.error('Error checking native platform:', error);
			return false;
		}
	}
}